import { forwardRef } from 'react'

import { getFocusRing, useFocusStyle } from '~/utils/focus'

import type { Props as ButtonBaseProps } from './button-base'
import { ButtonBase } from './button-base'

type Props = Omit<ButtonBaseProps, 'backgroundColor'>

const getTextColor = (variant: Props['variant']) => {
    if (variant === 'danger') {
        return 'dangerActive'
    }

    return variant
}

export const ButtonMinimalInternal = forwardRef<HTMLButtonElement, Props>(
    ({ variant = 'brand', css, color = getTextColor(variant), ...props }, ref) => (
        <ButtonBase
            ref={ref}
            backgroundColor="transparent"
            borderColor="transparent"
            color={color}
            variant={variant}
            isButtonWithLabel
            css={[
                {
                    '&:hover': {
                        ':not([aria-disabled="true"])': {
                            backgroundColor:
                                variant === 'danger' ? `${variant}Secondary` : `${variant}SecondaryHighlighted`,
                            color,
                        },
                    },
                    '&:focus': {
                        color,
                    },
                    ...getFocusRing(useFocusStyle(variant)),
                    '&:active': {
                        ':not([aria-disabled="true"])': {
                            backgroundColor:
                                variant === 'danger' ? `${variant}SecondaryHighlighted` : `${variant}SecondaryActive`,
                            color,
                        },
                    },
                    '&[aria-disabled="true"]': props.isLoading
                        ? /**
                           * Here an empty object needs to be passed, otherwise, the styling from the
                           * `ButtonBase` component won't be inherited.
                           */
                          {}
                        : {
                              backgroundColor: 'transparent',
                              color: 'backgroundEmphasis',
                          },
                },
                css,
            ]}
            {...props}
        />
    ),
)

ButtonMinimalInternal.displayName = 'ButtonMinimalInternal'
